import { useEffect } from "react"
import { trackRender } from "./performanceTracker"

export function useRenderTracker(name: string) {
  useEffect(() => {
    trackRender(name)
  })
}